import './AccountIcon.scss'

interface Props {
    account: Account
    size?: number
}

// Icône Font Awesome du compte sur un fond teinté de sa couleur.
const AccountIcon = ({ account, size = 22 }: Props) =>
    <span
        className="account-icon"
        style={{ width: size, height: size, fontSize: size * 0.5, color: account.color, backgroundColor: `${account.color}26` }}>
        <i className={`fa-solid fa-${account.icon || 'wallet'}`}/>
    </span>

export default AccountIcon
